/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Box, Button, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { TextFieldWithLabel } from 'Components/TextField'
import { sendPost } from 'hooks/use-fetch'
import styled from '@emotion/styled'
import GoogleIcon from '@mui/icons-material/Google'
import FacebookIcon from '@mui/icons-material/Facebook'
import { toast } from 'react-toastify'
import { saveSession, useCaregiverWizardContext, useCaregiverWizardUpdateDispatch } from 'ContextProviders/CaregiverWizard'
import { type EnrollmentDetails } from 'core/types'
import { useParams } from 'react-router'
import { useAuth } from 'hooks/use-auth'
const PrimaryButton = styled(Button)(`
  text-transform: none;
  padding:16px 40px;
`)
const LoginButton = styled(Button)(`
  text-transform: none;
  color:black;
  background-color:transparent;
  box-shadow:none;
  border: 1px solid #E7E7E7;
  border-radius:0px;
`)

export function AccountFound (): JSX.Element {
  const [pass, setPass] = useState('')
  const { isdId } = useParams()
  const caregiverForm = useCaregiverWizardContext()
  const caregiver = caregiverForm?.caregivers[0]
  const dispatch = useCaregiverWizardUpdateDispatch()
  const acct = useAuth()

  useEffect(() => {
    const navIfLoggedIn = async (): Promise<void> => {
      if (acct.user != null && acct.user.email === caregiver?.email && ((acct.user?.email ?? '') !== '')) {
        const step = 1
        const subStep = 2
        const tempForm = { ...caregiverForm, currentStep: step, currentSubStep: subStep } as EnrollmentDetails
        await saveSession(tempForm)
        dispatch({ type: 'form', form: tempForm })
      }
    }
    void navIfLoggedIn()
  }, [acct.user])

  const submit = async (): Promise<void> => {
    const retVal = await sendPost('/Account/CheckPassword', {
      email: caregiver?.email,
      password: pass
    })
    if (!retVal.success) {
      retVal.error.forEach(element => {
        toast.error(element)
      })
    } else {
      if (caregiverForm != null && caregiver != null) {
        const step = 0
        const subStep = 2
        const tempForm = { ...caregiverForm, currentStep: step, currentSubStep: subStep } as EnrollmentDetails
        await saveSession(tempForm)
        window.location.href = `${process.env.REACT_APP_SERVER_URL ?? ''}/Account/LoginWithUser?returnUrl=${process.env.REACT_APP_CLIENT_URL ?? ''}/CaregiverPortal/${isdId ?? ''}/Enrollments&email=${encodeURIComponent(caregiver.email)}&password=${encodeURIComponent(pass)}`
      }
    }
  }
  const loginWithGoogle = (): void => {
    window.location.href = `${process.env.REACT_APP_SERVER_URL ?? ''}/Account/GoogleLogin?returnUrl=${process.env.REACT_APP_CLIENT_URL ?? ''}/CaregiverPortal/${isdId ?? ''}/Enrollments`
  }
  const loginWithFacebook = (): void => {
    window.location.href = `${process.env.REACT_APP_SERVER_URL ?? ''}/Account/FacebookLogin?returnUrl=${process.env.REACT_APP_CLIENT_URL ?? ''}/CaregiverPortal/${isdId ?? ''}/Enrollments`
  }
  const goBack = async (): Promise<void> => {
    const step = 2
    const subStep = 2
    const tempForm = { ...caregiverForm, currentStep: step, currentSubStep: subStep } as EnrollmentDetails
    await saveSession(tempForm)
    dispatch({ type: 'form', form: tempForm })
  }
  return <Box>
    <Typography>Account Found</Typography>
    <Typography>It looks like you already have an account under <b>{caregiver?.email}</b>. Select one of the login options to pick up where you left off.</Typography>
    <TextFieldWithLabel
      name={'email'}
      onChange={() => {} }
      disabled={true}
      label='Email Address'
      value={caregiver?.email}
    />
    <TextFieldWithLabel
      name={'password'}
      label='Password'
      onChange={(e) => { setPass(e.target.value) }}
      value={pass}
      type='password'
      toolTip='Password'
    />
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Button fullWidth={false} sx={{ maxWidth: 'fit-content', marginLeft: 'auto' }} variant='text'>Forgot Password?</Button>
      <PrimaryButton variant='contained' onClick={submit}>Login With Email</PrimaryButton>
      <Typography sx={{ alignSelf: 'center' }}>or</Typography>
      <LoginButton variant='contained' onClick={loginWithGoogle}><GoogleIcon sx={{ width: '32px', height: '32px' }}/>Continue with Google</LoginButton>
      <LoginButton variant='contained' onClick={loginWithFacebook}><FacebookIcon sx={{ width: '32px', height: '32px', borderRadius: '30px' }}/>Continue with Facebook</LoginButton>
      <PrimaryButton variant='contained' onClick={goBack}>Go Back</PrimaryButton>
    </Box>
  </Box>
}
